import styled from 'styled-components';

import { themeSpace } from 'styles/themeUtils';

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: ${themeSpace(0.5)};
  padding-bottom: ${themeSpace(0.5)};

  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }
`;

ListItem.displayName = 'ListItem';
